module.exports = function() {
  return new Worker(__webpack_public_path__ + "1ec5aaeb0560d86049e5.worker.js");
};